import React from 'react';
import PropTypes from 'prop-types';
import translations from 'Translations';
import durationFormat from 'Misc/duration-format';
import './state-info.scss';

const getChromeVersion = () => {     
  var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
  return raw ? parseInt(raw[2], 10) : false;
}

const StateInfo = props => (
  <div className="state-info">
    <div className="state-info__item">{translations[props.settings.APP_NAME].name}</div>
    <div className="state-info__item">Chrome Version: { getChromeVersion() }</div>
    
    <div className="state-info__item">SETTINGS APP_NAME: { props.settings.APP_NAME }</div>

    <div className="state-info__item">SONIC URL: { props.state.sonic.host }</div>
    <div className="state-info__item">SONIC TOKEN: { props.state.sonic.token }</div>

    <div className="state-info__item">UI STATE: {props.state.ui}</div>
    <div className="state-info__item">PLAYER STATE: {props.state.player.state}</div>
    
    <div className="state-info__item">SHOWING ERROR?: {props.state.error ? 'YES' : 'NO'}</div>
    <div className="state-info__item">LAST ERROR TYPE: {props.state.lastError}</div>
    
    <div className="state-info__item">TIME CURRENT: {durationFormat(props.state.currentTime, props.state.duration)}</div>
    <div className="state-info__item">TIME TOTAL: {durationFormat(props.state.duration)}</div>
    <div className="state-info__item">LAST PLAYBACK REPORT AT: {durationFormat(props.state.playbackReportedTime)}</div>
    {
      (props.state.media) ?
      <div>
        <div className="state-info__item">VIDEO RESOLUTION: {props.state.videoResolution}</div>
        <div className="state-info__item">MEDIA requestId: {props.state.requestId}</div>
        <div className="state-info__item">MEDIA CONTENT: {props.state.media.contentId}</div>
        <div className="state-info__item">MEDIA CONTENT ID: {props.state.media.contentIdSonic}</div>
        <div className="state-info__item">MEDIA TITLE: {props.state.media.metadata.title}</div>
        <div className="state-info__item">MEDIA SUBTITLE: {props.state.media.metadata.subtitle}</div>
        <div className="state-info__item">MEDIA TYPE: {props.state.media.streamType}</div>
        <div className="state-info__item">MEDIA TRACKS: {JSON.stringify(props.state.media.tracks)}</div>
        {(props.state.media.customData && props.state.media.customData.protection) ?
          <div>
            <div className="state-info__item">MEDIA CLEARKEY ENABLED?: {props.state.media.customData.protection.clearkeyEnabled ? 'YES':'NO'}</div>
            <div className="state-info__item">MEDIA DRM ENABLED?: {props.state.media.customData.protection.drmEnabled ? 'YES':'NO'}</div>
          </div>
        : null
        }
      </div>
      : null
    }
    { (props.state.mediaAttributes) ? 
      <div>
        <div className="state-info__item">ANALYTICS ID: {props.state.mediaAttributes.identifiers.analyticsId}</div>
      </div>
      : null
    }
  </div>
);

export default StateInfo;

StateInfo.propTypes = {
  state: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/state-info/index.js